'use strict'

const state = () => {
    return {
        keyword: '',
        search: false
    }
}

// getters
const getters = {
    keyword: function (state) {
        return state.keyword
    },
    search: function (state) {
        return state.search
    }
}

// actions
const actions = {
    async fetchSearch({ commit }, { url, params = {} }) {
        return this.client.Get(`${url}`, {
                query: params,
                callback: function (response) {
                    commit('data', response);
                }
        });
    },

}

// mutations
const mutations = {
    keyword (state, payload) {
        state.keyword = payload
    },
    search (state, payload) {
        if (!payload) return false;
        state.search = payload.content
        state.keyword = payload.content.keyword
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}